export function measureFetcher(measureType: string) {
  switch (measureType) {
    case 'temperature':
      return 'asset.measures.temperature.degree';
  }
}
